import { createPerformableConfig, TenantId } from '~/tenants/common/registry';
import { coerceLiteralNumberRequired, FIRST_VERSION_TIMESTAMP } from '~/lib/zod';
import z from 'zod';

export default createPerformableConfig(
  'nucleus-guided',
  {
    [FIRST_VERSION_TIMESTAMP]: z.object({
      version: coerceLiteralNumberRequired(FIRST_VERSION_TIMESTAMP),
      guided: z.coerce.number().min(1),
    }),
  },
  {
    name: 'Nucleus Live Virtual Tours',
    short: 'Host real-time guided showings where you can walk clients through the property remotely and answer questions live.',
    thumbnail: 'tenant/twt/nucleus/live_guided.png',
    color: '#8e51b1',
    tenant: TenantId.TWIST_TOURS,
    images: [],
  },
);
